module.exports = {"build":"prod","locale":"ko"}


//////////////////
// WEBPACK FOOTER
// ./src/config/app.config.json
// module id = sY4+
// module chunks = 25